<template>
  <div id="content" class="app-content">
    <!-- page header -->
    <b-row>
      <b-col>
        <h1 class="page-header">CSV Codes Batch <small>all listings.</small></h1>
      </b-col>

      <b-col sm="auto" class="ml-auto">
        <b-button :disabled="$cannot('supplier.manage')" v-b-modal.newCSVCodeBatch>
          New Batch
        </b-button>

        <b-modal title="New Code Batch" id="newCSVCodeBatch" hide-footer v-slot:default="{ close }">
          <csv-codes-batch-form @close="refresh(close)" />
        </b-modal>
      </b-col>
    </b-row>

    <!-- page content -->
    <b-card>
      <b-form-input
        v-model="variation_filter"
        @input="loadContent"
        placeholder="Search by variation name"
        class="mb-4"
      />
      <b-form-group label="Show expired">
        <b-form-checkbox v-model="expired" @change="loadContent" />
      </b-form-group>
      <b-table :fields="fields" :items="listing" show-empty stacked="sm" bordered hover>
        <template v-slot:cell(options)="row">
          <b-button variant="default" size="sm" v-b-modal="`editCSVCodeBatch-${row.item.id}`">
            Edit
          </b-button>

          <b-modal title="Edit Batch Details" :id="`editCSVCodeBatch-${row.item.id}`" hide-footer>
            <csv-codes-batch-form :batch="row.item" />
          </b-modal>
        </template>
      </b-table>

      <!-- pagination -->
      <b-pagination
        v-model="meta.current_page"
        :total-rows="meta.total"
        :per-page="meta.per_page"
        @change="paginationChange"
      />
    </b-card>
  </div>
</template>

<script>
import { products } from '@youwish1/api-package'
import CsvCodesBatchForm from './CSVCodesBatchForm'
import { formatDate } from '@/pages/page-helpers'

export default {
  name: 'CSVCodes',
  inject: ['$cannot'],
  components: { CsvCodesBatchForm },
  data() {
    return { listing: [], meta: {}, variation_filter: '', expired: false }
  },
  computed: {
    fields() {
      return [
        { key: 'id', label: 'ID' },
        {
          key: 'product_id',
          label: 'Product ID',
          formatter: (value, key, item) => {
            return item.product_variation.product_id
          },
        },
        {
          key: 'product_variation',
          label: 'Variation',
          formatter: variation => variation.variation_name,
        },
        {
          key: 'supplier',
          formatter: supplier => supplier.booking_name,
        },
        {
          key: 'place',
          formatter: place => place.name,
        },
        { key: 'num_codes', label: 'Codes' },
        { key: 'used_codes', label: 'Used' },
        { key: 'alert_when' },
        { key: 'valid_for' },
        { key: 'start_time', formatter: date => formatDate(date) },
        { key: 'end_time', formatter: date => formatDate(date) },
      ]
    },
  },
  beforeRouteEnter(from, to, next) {
    next(vm => vm.loadContent())
  },
  methods: {
    async loadContent() {
      const page = this.$route.query.page ?? 1
      const response = await products.variations.batches.go(page, {
        filter: {
          variation_name: this.variation_filter,
          expired: this.expired,
        },
      })

      this.$nextTick(() => {
        this.listing = response.data().map(data => {
          const {
            product_variation: { supplier, place },
          } = data

          return { ...data, ...{ supplier }, ...{ place } }
        })
        this.meta = response.meta
      })
    },

    paginationChange(page) {
      this.$router.push(page === 1 ? { name: 'csvcodes' } : { name: 'csvcodes', query: { page } })

      this.loadContent()
    },

    refresh(callback) {
      this.loadContent()
      this.paginationChange(this.meta.last_page)
      callback()
    },
  },
}
</script>
